import { render, staticRenderFns } from "./Nametags.vue?vue&type=template&id=328f4e83&"
import script from "./Nametags.vue?vue&type=script&lang=js&"
export * from "./Nametags.vue?vue&type=script&lang=js&"
import style0 from "./Nametags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports